import { CreateUserCommunityAgreementDto } from './create-user-community-agreement-dto';

export class CreateEventUserAgreementDto extends CreateUserCommunityAgreementDto {
  bookingId: string;
}
